import { Button, Tooltip } from "antd";
import React from "react";
import "./index.css";

function AuthZButton({
  tooltipPlacement,
  tooltipTitle,
  tooltipStyle,
  tooltipTrigger = ["hover"],
  icon,
  onClick,
  buttonClassName,
  buttonStyle,
  buttonDisabled,
  buttonShape,
  buttonType,
  buttonSize,
  buttonLoading,
  children,
  authZButtonType,
  ariaLabel,
  getPopupContainer,
  dataTestId
}) {
  const popupContainer = getPopupContainer ?? (()=> document.body);
  if (authZButtonType === "primary") {
    buttonClassName = "authz-primary-button";
  } else if (authZButtonType === "default") {
    buttonClassName = "authz-default-button";
  } else if (authZButtonType === "secondary") {
    buttonClassName = "authz-secondary-button";
  }
  const testIdProps = dataTestId ? {"data-testid": dataTestId} : {};

  return (
    <Tooltip
      title={tooltipTitle}
      placement={tooltipPlacement}
      overlayStyle={tooltipStyle}
      overlayInnerStyle={{ textAlign: "justify" }}
      trigger={tooltipTrigger}
      getPopupContainer={popupContainer}
    >
      <Button
        icon={icon}
        onClick={onClick}
        className={buttonClassName}
        style={buttonStyle}
        shape={buttonShape}
        disabled={buttonDisabled}
        type={buttonType}
        size={buttonSize}
        loading={buttonLoading}
        aria-label={ariaLabel}
        {...testIdProps}
      >
        {children}
      </Button>
    </Tooltip>
  );
}

export default AuthZButton;
